import { render, staticRenderFns } from "./QuotationsList.vue?vue&type=template&id=103f3d72&scoped=true&"
import script from "./QuotationsList.vue?vue&type=script&lang=js&"
export * from "./QuotationsList.vue?vue&type=script&lang=js&"
import style0 from "./QuotationsList.vue?vue&type=style&index=0&id=103f3d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103f3d72",
  null
  
)

export default component.exports